export const showDate = (dateString:any) => {
    if (!dateString) return '';  
  
    const date = new Date(dateString);
    return date.toLocaleDateString("fr-FR", {
      day: "numeric",
      month: "numeric",
      year: "numeric",
    });
  };